import Image from "next/image";
import Link from "next/link";

export default function Logo() {
  return (
    <Link className="block" href="/" aria-label="CalSetter">
      <div className="text-lg flex flex-row items-center gap-2 font-bold">
        <Image
          src={"/callcow.png"}
          width={38}
          height={38}
          priority
          alt="CalSetter Logo"
        />
        <div>
          Cal<span className="text-brandOG">Setter</span>AI
        </div>
      </div>
    </Link>
  );
}
